export const pageItemIdPathMap = {
  "privacy-policy": "/privacy-policy",
  "email-request": "/email-request",
  "email-signature": "/email-signature",
  "payment-request": "/payment-request",
  "estimate-request-management-list": "/estimate-request",
  "training-request": "/training-request",
  "all-news": "/news",
  "all-events": "/events",
  "manage-libraries": "/dms/library",
  "extenso-report-list": "/extenso",
  "reports_shop-performance": "/reports/shop-performance",
  "reports_vehicle-location": "/reports/vehicle-location",
  "shop-profile": "/shop-profile",
  "contact-us": "/contact-us",
  "reports_waiting-list": "/reports/waiting-list",
  "cms-editor-list": "/cms-editor",
  "cms-editor-create": "/cms-editor/create",
  "shop-hours-management": "/shop-hours-management",
  "publication-management": "/manage/publications",
  "publication-article-edit": "/manage/publications/articles/[id]",
  "publication-label-edit": "/manage/publications/labels/[id]",
  "publication-category-edit": "/manage/publications/category/[id]",
  "publication-article-create": "/manage/publications/articles/create",
  "publication-label-create": "/manage/publications/labels/create",
  "publication-category-create": "/manage/publications/categories/create",
  "advertisement-banner-management-list": "/manage/advertisement-banner",
  "advertisement-banner-management-create":
    "/manage/advertisement-banner/create",
  "advertisement-banner-management-edit": "/manage/advertisement-banner/edit",
  "novus-products-page": "/novus-products",
  "shop-sales-submission-create": "/shop-sales/create",
  "shop-hours-management-admin": "/shop-hours-management/admin",
  manage: "/manage",
  logout: "/logout", // TODO support "regionless" paths
  search: "/search",
  home: "/",
  "financial-account": "/financial",
  "royalty-payment": "/shop-sales/royalty-payment",
  "nps-survey-management": "/manage/nps",
  "news-create": "/manage/publications/news-article/create",
  "event-create": "/manage/publications/event-article/create",
  "interactive-map-page": "/interactive-map",
  "dms-permission-diagnostic": "/dms/permission-diagnostic",
  "shop-list-page": "/shop-list",
  "manage-suggestions": "/manage/suggestions",
  impersonate: "/manage/impersonate",
  "logo-management": "/manage/logos",
  "pitstop-alert-management": "/manage/pitstop-alerts",
} as const;

export type PageId = keyof typeof pageItemIdPathMap;
